import React from 'react';

import { contestUrl } from 'buyside/util/urlHelper';

const contestBadge = ({ contestIdea, className = '' }) => {
  if (!contestIdea) return null;

  let imageSrc;
  switch (contestIdea.award) {
    case '4winner':
      imageSrc = '/images/pro/contest_gold.png';
      break;
    case '3finalist':
      imageSrc = '/images/pro/contest_silver.png';
      break;
    case '2runner_up':
      imageSrc = '/images/pro/contest_bronze.png';
      break;
    case '1honoree':
      imageSrc = '/images/pro/contest_honoree.png';
      break;
  }
  if (!imageSrc) return null;
  return (
    <a href={contestUrl(contestIdea.contestId)}>
      <img src={imageSrc} className={className} />
    </a>
  );
};

export default contestBadge;
